module.exports = __webpack_public_path__ + "static/media/logoxxxhdpi.e5f879de.png";